
import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch
} from "react-router-dom";
import TerminosYCondiciones from "./pages/TerminosYCondiciones";

import Home from './Components/Home';

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/terminos-y-condiciones" component={TerminosYCondiciones} />
      </Switch>
    </Router>
  );
}

export default App;

